/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'
import moduleRoles from './role-management/moduleRoleManagement.js'
import moduleManagement from './custom-module-management/customModulesManagement.js'
import moduleMenuBuilder from './menu-builder/moduleMenuBuilder.js'
import moduleDashboardAnalytics from './dashboard-analytics/moduleDashboardAnalytics.js'
import moduleKanban from './kanban/moduleKanban'
import moduleRelatedModuleNavigation from './related-module-navigation/moduleRelatedModuleNavigation.js'


export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    eCommerce: moduleECommerce,
    roles: moduleRoles,
    customModules: moduleManagement,
    menuBuilder: moduleMenuBuilder,
    dashboardAnalytics: moduleDashboardAnalytics,
    kanban: moduleKanban,
    relatedModuleNavigation: moduleRelatedModuleNavigation
  },
  strict: process.env.NODE_ENV !== 'production'
})
